import { FlattenedPage } from "@types-runway/questionnaire";

type ScreenLeft = Pick<FlattenedPage, "stateKey">;

interface TimeLeftContext {
  isAwaitingRecommendations: boolean;
}

const effortSecondsByStateKey: Record<string, number> = {
  dob: 20,
  biometrics: 30,
  stateOfResidence: 20,
  assignedSex: 10,
  pregnant: 10,
  travelDestination: 25,
  travelDates: 30,
  addOns: 30,
  allergies: 20,
  adultVaccines: 25,
  fallingAsleep: 10,
  referralSource: 10,
  parentalConsent: 120,
};

const estimateEffortSeconds = (
  screensLeft: ScreenLeft[],
  { isAwaitingRecommendations }: TimeLeftContext
): number => {
  const defaultEffortSeconds = 15;
  const recommendationsWaitSeconds = 5;
  const screensEffort = screensLeft.reduce(
    (total, screen) => total + (effortSecondsByStateKey[screen.stateKey] ?? defaultEffortSeconds),
    0
  );

  return isAwaitingRecommendations ? screensEffort + recommendationsWaitSeconds : screensEffort;
};

interface TimeLeft {
  label: string;
  // The minutes the chip shows the patient; null when it counts questions instead.
  shownMinutes: number | null;
}

export const deriveTimeLeft = (screensLeft: ScreenLeft[], context: TimeLeftContext): TimeLeft => {
  const quickScreenLimit = 3;
  const underTwoMinutesSeconds = 120;
  const effortSeconds = estimateEffortSeconds(screensLeft, context);

  if (screensLeft.length === 1) {
    return { label: "Last question", shownMinutes: null };
  }
  if (screensLeft.length <= quickScreenLimit) {
    return { label: `${screensLeft.length} quick questions left`, shownMinutes: null };
  }
  if (effortSeconds > underTwoMinutesSeconds) {
    const minutes = Math.ceil(effortSeconds / 60);

    return { label: `About ${minutes} min left`, shownMinutes: minutes };
  }

  return { label: "Under 2 min left", shownMinutes: 2 };
};
